import React, { Component } from 'react'
import { Button, Icon, Table } from 'antd'
import { siteContent } from '@services/api'

export default class extends Component {
    render() {
        let columns = [
            {
                title: 'שפה',
                key: 'lng',
                width: 40,
                align: 'center',
                render: (_, record) => <span key={record.lng}>{record.lng}</span>
            },
            {
                title: 'מיקום',
                key: 'component',
                width: 40,
                align: 'center',
                render: (_, record) => (
                    <span>
                        {record.component == '_' ? 'משותף' : record.component.substring(0, record.component.length - 1)}
                    </span>
                )
            },
            {
                title: 'מפתח',
                key: 'key',
                width: 40,
                align: 'center',
                render: (_, record) => <span>{record.component != 'faq_' ? record.key.key : 'faq'}</span>
            },
            {
                title: 'טקסט',
                key: 'text',
                width: 300,
                align: 'center',
                render: (_, record) => {
                    const { value } = record.key
                    return record.component != 'faq_' ? (
                        <span>{value}</span>
                    ) : (
                        <>
                            <span>{`q: ${value.q}`} </span>
                            <br />
                            <span> {`a: ${value.a}`}</span>
                        </>
                    )
                }
            },
            {
                title: '',
                key: 'edit',
                width: 50,
                align: 'right',
                render: (_, record) => {
                    return (
                        <Button
                            onClick={async () => {
                                await siteContent.deleteKey(record)
                                this.props.updateSiteContent()
                            }}
                        >
                            <Icon type="delete" />
                        </Button>
                    )
                }
            }
        ]
        return (
            <Table
                rowKey={(_, idx) =>
                    _.component != 'faq_' ? `${_.key.value}${idx}` : `${_.key.value.q}${_.key.value.a}${idx}`
                }
                dataSource={this.props.arr}
                columns={columns}
            />
        )
    }
}
